(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'RequestHotel',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load($form)
	{
		$('#requesthotel-check_in_date').on('dp.change', function dateChange(e) {
			var $checkout_date;

			if (e.date === false) {
				return;
			}

			$checkout_date = $('#requesthotel-check_out_date');
			$checkout_date.data('DateTimePicker').date(e.date.add(1, 'days'));
		});
	};
}(jQuery, window.Adzuki || {}));
